export const priorityOptions = [
  { label: "Normal", value: "NORMAL" },
  { label: "Urgent", value: "URGENT" },
  { label: "Immediate", value: "IMMEDIATE" },
];

export const mediaOptions = [
  { label: "Phone", value: "PHONE" },
  { label: "SMS", value: "SMS" },
  { label: "Email", value: "EMAIL" },
];

export const feedbackOptions = [{ label: "Feedback", value: "FEEDBACK" }];

export const residOptions = [{ label: "Residence", value: "RESIDENCE" }];

export const categoryOptions = [
  { label: "Lift / Escalator", value: "LIFT_ESCALATOR" },
  { label: "Bulky Item Removal", value: "BULKY_ITEM_REMOVAL" },
];

export const statusOptions = [
  { label: "Open", value: "OPEN" },
  { label: "Not complete", value: "NOT_COMPLETE" },
  { label: "Complete", value: "COMPLETE" },
  { label: "Dispatched", value: "DISPATCHED" },
  { label: "Collected", value: "COLLECTED" },
  { label: "Closed", value: "CLOSED" },
  { label: "Cancelled", value: "CANCELLED" },
];

export const subcategoryOptions = [
  { label: "Lift Surveillance System", value: "LIFT_SURVEILLANCE_SYSTEM" },
  { label: "Defective Lighting", value: "DEFECTIVE_LIGHTING" },
  { label: "Defective Fans", value: "DEFECTIVE_FANS" },
  { label: "Defective Device", value: "DEFECTIVE_DEVICE" },
  { label: "Urine Detection Device", value: "URINE_DETECTION_DEVICE" },
  { label: "Defective HPI or CPI", value: "DEFECTIVE_HPI_OR_CPI" },
  { label: "Landing Not level", value: "LANDING_NOT_LEVEL" },
  {
    label: "Lift Door closing and opening too fast",
    value: "LIFT_DOOR_CLOSING_AND_OPENING_TOO_FAST",
  },
  { label: "Lift Jerky", value: "LIFT_JERKY" },
  { label: "Lift Shaky & vibration", value: "LIFT_SHAKY_VIBRATION" },
  { label: "Defective button", value: "DEFECTIVE_BUTTON" },
  { label: "Stuck, door or lift stuck", value: "STUCK_DOOR_OR_LIFT_STUCK" },
  { label: "Lift breakdown", value: "LIFT_BREAKDOWN" },
  { label: "Lift jammed", value: "LIFT_JAMMED" },
  {
    label: "Bulky Item Removal Appointment",
    value: "BULKY_ITEM_REMOVAL_APPOINTMENT",
  },
];
